<div class="chart-title">{{'Blood Alcohol Content' | translate}}</div>
<apx-chart [series]="barChartOptions.series" [chart]="barChartOptions.chart" [xaxis]="barChartOptions.xaxis"
    [matTooltip]="barChartOptions.title"></apx-chart>
<span *ngIf="!barChartOptions">{{'No data yet.' | translate}}</span>